<div class="p-3 mt-1 card border rounded">
  <div class="mb-3 border-bottom border-secondary-subtle">
    <div class="d-flex justify-content-between">
      <div>
        <p class="p-0 m-0 text-dark fw-bolder fs-22">
          {{ 'CONTRACT.PAYMENTS' | translate }}
        </p>
        <p class="p-0 m-0 text-dark text-muted">
          {{ 'CONTRACT.PAYMENTS_DESC' | translate }}
        </p>
      </div>
      <div class="text-md-end">
        <button (click)="onEdit()" class="btn btn-primary btn-sm cursor-pointer">
          <i class="las la-edit"></i>{{ 'CONTRACT.EDIT' | translate }}
        </button>
      </div>
    </div>
  </div>

  <div class="d-flex flex-column gap-2">
    <div>
      <p class="p-0 m-0 fw-bold fs-5">
        {{ 'CONTRACT.OPERATING_COST_QUESTION' | translate }}
      </p>
      <p class="p-0 m-0 text-muted">
        {{ getRateTypeLabel(data()?.unitType) | translate }}
      </p>
    </div>

    <ng-container *ngIf="getRateTypeFields(data()?.unitType) as fields">
      <div *ngFor="let field of fields" class="d-flex flex-wrap gap-2">
        <div class="w-50">
          <p class="p-0 m-0 fw-bold fs-5">
            {{ field.label | translate }}
          </p>
          <p class="p-0 m-0 text-muted">
            {{ data()?.[field.id] | moneyFormat }}
          </p>
        </div>
      </div>
    </ng-container>

    <div class="d-flex flex-wrap gap-2">
      <div class="w-50">
        <p class="p-0 m-0 fw-bold fs-5">
          {{ 'CONTRACT.VALID_FROM' | translate }}
        </p>
        <p class="p-0 m-0 text-muted">
          {{ data()?.startDate | localizedDate }}
        </p>
      </div>
      <div *ngIf="data()?.unitType !== ContractRateType.FlatRateRent" class="w-50">
        <p class="p-0 m-0 fw-bold fs-5">
          {{ 'CONTRACT.TOTAL_RENT' | translate }}
        </p>
        <p class="p-0 m-0 text-muted">
          {{ data()?.totalRent | moneyFormat }}
        </p>
      </div>
    </div>
  </div>
</div>
